import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Gift, X } from 'lucide-react';
import { TeamBonusPreviewPanel } from './TeamBonusPreviewPanel';

interface StaffBonusOverviewModalProps {
    isOpen: boolean;
    onClose: () => void;
    currencySymbol?: string;
}

/**
 * Aufklappbares Modal für Bonus-Vorschau (Team- oder Einzel-Boni, HJ1 + HJ2).
 */
export const StaffBonusOverviewModal: React.FC<StaffBonusOverviewModalProps> = ({
    isOpen,
    onClose,
    currencySymbol = '€',
}) => {
    useEffect(() => {
        if (!isOpen) return;
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = prev;
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return createPortal(
        <div className="fixed inset-0 z-[100000] flex items-center justify-center bg-black/75 p-4 md:p-8">
            <div
                className="absolute inset-0"
                onClick={onClose}
                aria-hidden
            />
            <div className="relative z-10 flex max-h-[90vh] w-full max-w-3xl flex-col overflow-hidden rounded-2xl border border-amber-500/40 bg-slate-950 shadow-2xl">
                <div className="flex items-center justify-between gap-3 border-b border-slate-800 px-4 py-3">
                    <div className="flex items-center gap-2">
                        <Gift className="h-4 w-4 text-amber-400" />
                        <div>
                            <p className="text-[10px] font-black uppercase tracking-[0.2em] text-amber-400">
                                Änderungszentrale
                            </p>
                            <h2 className="text-base font-black uppercase tracking-wider text-white">
                                Anstehende Boni
                            </h2>
                        </div>
                    </div>
                    <button
                        type="button"
                        onClick={onClose}
                        className="rounded-lg border border-slate-700 bg-slate-900 p-2 text-slate-400 hover:text-white"
                        aria-label="Schließen"
                    >
                        <X className="h-4 w-4" />
                    </button>
                </div>
                <div className="min-h-0 flex-1 overflow-y-auto p-4">
                    <TeamBonusPreviewPanel currencySymbol={currencySymbol} showIndividual />
                </div>
            </div>
        </div>,
        document.body
    );
};

export default StaffBonusOverviewModal;
